import { useEffect, useState } from 'react';
import env from '../../config/env';
import './SelectedModelInput.css';

function SelectedModelInput({ handleSelectModel, resetInput }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [show, setShow] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (resetInput) {
      setSearchTerm('');
      setSearchResults([]);
      setShow(false);
      setError(null);
    }
  }, [resetInput]);

  const handleInputChange = async (event) => {
    const inputValue = event.target.value;
    setSearchTerm(inputValue);
    setError(null);

    if (!inputValue.trim()) {
      setSearchResults([]);
      setShow(false);
      setLoading(false);
      return;
    }

    setShow(true);
    setLoading(true);

    try {
      const response = await fetch(
        `${env.baseUrlApi}/vehicleModels/${encodeURIComponent(inputValue)}`
      );

      if (!response.ok) {
        throw new Error('Erreur lors de la recherche du modèle');
      }

      const jsonData = await response.json();
      setSearchResults(Array.isArray(jsonData) ? jsonData : []);
    } catch (err) {
      console.error('Erreur de recherche du modèle :', err);
      setError(err);
      setSearchResults([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectModelInput = (suggestion) => {
    setSearchTerm(suggestion.modele);
    setSearchResults([]);
    setShow(false);
    handleSelectModel(suggestion);
  };

  const handleClearInput = () => {
    setSearchTerm('');
    setSearchResults([]);
    setShow(false);
    setError(null);
  };

  return (
    <div className="mc-model-search">
      <div className="mc-model-input-wrapper">
        <span className="mc-model-icon" aria-hidden="true">
          <i className="bi bi-car-front" />
        </span>

        <input
          type="text"
          className="mc-model-input"
          name="vehicleModel"
          required
          value={searchTerm}
          onChange={handleInputChange}
          placeholder="Marque et modèle du véhicule..."
          autoComplete="off"
          onFocus={() => {
            if (searchTerm.trim()) setShow(true);
          }}
          onBlur={() => {
            setTimeout(() => setShow(false), 200);
          }}
        />

        {searchTerm && (
          <button
            type="button"
            className="mc-model-clear"
            onMouseDown={(event) => event.preventDefault()}
            onClick={handleClearInput}
            aria-label="Effacer le modèle"
          >
            <i className="bi bi-x-lg" />
          </button>
        )}
      </div>

      {show && searchTerm.trim() && (
        <div className="mc-model-dropdown">
          {loading && (
            <div className="mc-model-state">
              <span className="mc-model-spinner" />
              Recherche des modèles...
            </div>
          )}

          {!loading && error && (
            <div className="mc-model-state">Impossible de rechercher les modèles.</div>
          )}

          {!loading && !error && searchResults.length === 0 && (
            <div className="mc-model-state">Aucun modèle trouvé.</div>
          )}

          {!loading && !error && searchResults.length > 0 && (
            <ul className="mc-model-result-list">
              {searchResults.map((suggestion, index) => (
                <li key={suggestion._id || index}>
                  <button
                    type="button"
                    className="mc-model-result"
                    onMouseDown={(event) => event.preventDefault()}
                    onClick={() => handleSelectModelInput(suggestion)}
                  >
                    <span className="mc-model-result-icon">
                      <i className="bi bi-car-front" />
                    </span>

                    <span className="mc-model-result-content">
                      <span className="mc-model-result-title">{suggestion.modele}</span>
                      <span className="mc-model-result-brand">{suggestion.marque}</span>
                    </span>

                    <i className="bi bi-chevron-right mc-model-result-arrow" />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default SelectedModelInput;
